export var BusinessCardType = function (BusinessCardType) {
  BusinessCardType["BUSINESS_PERSONAL_STORED_CARD"] = "BUSINESS_PERSONAL_STORED_CARD";
  BusinessCardType["BUSINESS_CENTRALLY_STORED_CARD"] = "BUSINESS_CENTRALLY_STORED_CARD";
  return BusinessCardType;
}({});